module.exports = __webpack_public_path__ + "static/media/icon／icon_jiaoyixiangqing_yiwancheng.99a4d341.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon／icon_jiaoyixiangqing_yiwancheng.png
// module id = 1778
// module chunks = 0 1